import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { movePiece, tempMove } from '../store/gameSlice';
import './board.css';
import { board_size } from '../config';
import { STATUS } from '../status';

const Board = () => {
  const dispatch = useDispatch();
  const { board, history, status, loading, winner, depth, index } = useSelector((state) => state.game);

  const handleClick = (i, j) => {
    if (loading || status !== STATUS.GAMING) return;
    if (board[i][j] === 0) {
      dispatch(tempMove([i, j]))
      dispatch(movePiece({ position: [i, j], depth }));
    }
  };

  useEffect(() => {
    if (winner === 1 || winner === -1) {
      const message = winner === 1 ? 'Black wins!' : 'White wins!';
      setTimeout(() => {
        window.alert(message);
      }, 300);
    }
  }, [winner]);

  // 创建坐标标签
  const renderCoordinates = () => {
    const elements = [];
    const cellSize = 100 / (board_size - 1);
    const letters = 'ABCDEFGHJKLMNOP'; // 不使用字母I以避免与数字1混淆
    
    // 添加顶部字母坐标
    for (let j = 0; j < board_size; j++) {
      elements.push(
        <div 
          key={`top-${j}`}
          className="coordinate-label top"
          style={{
            left: `${j * cellSize}%`,
          }}
        >
          {letters[j]}
        </div>
      );
    }
        
    // 添加左侧数字坐标（从上到下递增）
    for (let i = 0; i < board_size; i++) {
      elements.push(
        <div 
          key={`left-${i}`}
          className="coordinate-label left"
          style={{
            top: `${i * cellSize}%`,
          }}
        >
          {board_size - i}
        </div>
      );
    }
    
    return elements;
};

  // 创建棋盘线条
  const renderGridLines = () => {
    const lines = [];
    const cellSize = 100 / (board_size - 1);
    
    // 横线
    for (let i = 0; i < board_size; i++) {
      const position = `${i * cellSize}%`;
      lines.push(
        <div 
          key={`h-${i}`} 
          className="grid-line horizontal" 
          style={{ top: position }}
        />
      );
    }
    
    // 竖线
    for (let i = 0; i < board_size; i++) {
      const position = `${i * cellSize}%`;
      lines.push(
        <div 
          key={`v-${i}`} 
          className="grid-line vertical" 
          style={{ left: position }}
        />
      );
    }
    
    return lines;
};

  // 创建交叉点、星位标记和棋子
  const renderBoard = () => {
    const elements = [];
    const cellSize = 100 / (board_size - 1);
    
    // 添加星位标记
    const starPoints = [
      [3, 3],
      [3, board_size - 4],
      [board_size - 4, 3],
      [board_size - 4, board_size - 4],
      [Math.floor(board_size / 2), Math.floor(board_size / 2)]
    ];
    
    starPoints.forEach(([i, j]) => {
      elements.push(
        <div 
          key={`star-${i}-${j}`}
          className="star-point"
          style={{
            left: `${j * cellSize}%`,
            top: `${i * cellSize}%`,
          }}
        />
      );
    });
    
    // 添加交叉点和棋子
    for (let i = 0; i < board_size; i++) {
      for (let j = 0; j < board_size; j++) {
        // 添加交叉点（用于点击）
        elements.push(
          <div 
            key={`int-${i}-${j}`}
            className="intersection"
            style={{
              left: `${j * cellSize}%`,
              top: `${i * cellSize}%`,
            }}
            onClick={() => handleClick(i, j)}
          />
        );
        
        // 如果有棋子，添加棋子
        if (board[i][j] !== 0) {
          let pieceClassname = 'piece';
          pieceClassname += board[i][j] === 1 ? ' black' : ' white';
          
          let number = 0;
          if (index) {
            for(let x = 0; x < history.length; x++) {
              if (history[x].i === i && history[x].j === j) {
                number = x + 1;
                break;
              }
            }
          }
          
          elements.push(
            <div 
              key={`piece-${i}-${j}`}
              className={pieceClassname}
              style={{
                left: `${j * cellSize}%`,
                top: `${i * cellSize}%`,
              }}
            >
              {number === 0 ? '' : number}
            </div>
          );
        }
        
        // 检查是否是最后一步
        const lastMove = history[history.length - 1];
        if (lastMove && lastMove.i === i && lastMove.j === j) {
          elements.push(
            <div 
              key={`last-${i}-${j}`}
              className="last"
              style={{
                left: `${j * cellSize}%`,
                top: `${i * cellSize}%`,
              }}
            />
          );
        }
      }
    }
    
    return elements;
  };

  return (
    <div className="board-container">
      {loading && (
        <div className="ai-thinking-banner">
          <div className="loading-spinner"></div>
          <div className="loading-text">AI thinking... 人工智能思考中...</div>
        </div>
      )}
      <div className="board">
        <div className="board-grid">
          {renderCoordinates()}
          {renderGridLines()}
          {renderBoard()}
        </div>
      </div>
    </div>
  );
};

export default Board;
